import React from 'react';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { Auth0Wrapper, useAuth0Context } from './auth/auth0'
import { routeTree } from './routeTree';
import { ThemeProvider } from './components/theme-provider';
import { Spinner } from './components/ui/spinner';
import { Toaster } from './components/ui/sonner';

// Create a new router instance
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: {
    auth: undefined!
  }
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Clean up on HMR to prevent duplicate router errors
// Note: router.destroy() was removed in newer versions of TanStack Router
// if (module.hot) {
//   module.hot.dispose(() => {
//     router.destroy();
//   });
// }

/**
 * Wrapper for checking Auth state
 * @returns Router | Loader
 */
function InnerApp() {
  const auth = useAuth0Context()
  return auth.isLoading ?
    <div className="flex h-screen items-center justify-center">
      <Spinner className="size-8" />
    </div> :
    <RouterProvider router={router} context={{ auth }} />
}

function App() {
  return (
    <Auth0Wrapper>
      <ThemeProvider defaultTheme="dark" storageKey="ui-theme">
        <InnerApp />
        <Toaster position="top-center"/>
      </ThemeProvider>
    </Auth0Wrapper>
  )
}

export default App

